import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";

export function isTokenExpired(token) {
  if (!token) return true;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000);

    return decoded.exp < currentTime;
  } catch (error) {
    return true;
  }
}

export function useTokenExpired(token) {
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    setIsExpired(isTokenExpired(token));
  }, [token]);

  return isExpired;
}

export default useTokenExpired;
